import { useRouter } from "@tanstack/react-router"
import { useLoginMutation } from "modules/auth/hooks/useLoginMutation"
import { useAuth } from "modules/shared/hooks/useAuth"
import { LoginSchema } from "schema"
import { z } from "zod"
import { LoginForm } from "./LoginForm"
import { AuthWrapper } from "../AuthWrapper"

export function Login() {
  const { mutate, isPending } = useLoginMutation()
  const { onLogin } = useAuth()
  const router = useRouter()

  const onSubmitLogin = async (data: z.infer<typeof LoginSchema>) => {
    mutate(data, { onSuccess: (response) => onLogin(response, router) })
  }

  return (
    <AuthWrapper>
      <LoginForm onSubmit={onSubmitLogin} isPending={isPending} isValid={true} />
    </AuthWrapper>
  )
}
